import { observer } from 'src/utils/mobx-react';
import React from 'react';
import { ExpandButton } from 'src/domains/sportsbook/webview/components/expandButton/ExpandButton';
import { RowMarketsState } from 'src/domains/sportsbook/webview/components/raceSummary/templates/rowMarkets/summaryMarkets/RaceSummaryRowMarkets.state';
import { I18n } from 'src/domains/layouts/webview/components/language/I18n';
import { EventId } from 'src_common/common/websocket2/id/WebsocketId';
import { SelectionCaption } from 'src/domains/sportsbook/webview/components/raceSummary/raceSummarySport/RaceSummaryNew.style';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';
import {
    RaceCaption,
    RunnerCaption,
} from 'src/domains/sportsbook/webview/components/raceSummary/templates/rowMarkets/summaryMarkets/RaceSummaryRowMarkets.style';
import { useCommon } from 'src/domains/common/Common';
import { RaceSummaryRowMarket } from 'src/domains/sportsbook/webview/components/raceSummary/templates/rowMarkets/summaryMarket/RaceSummaryRowMarket';

export type RaceSummaryRowMarketsConfigType = {
    displayShowMoreButton: boolean;
    withTableHeader: boolean;
};

type RaceSummaryRowMarketsPropsType = {
    eventId: EventId;
    state: RowMarketsState;
    config: RaceSummaryRowMarketsConfigType;
};

export const RaceSummaryRowMarkets = observer('RaceSummaryRowMarkets', (props: RaceSummaryRowMarketsPropsType) => {
    const { state, eventId } = props;
    const common = useCommon();
    const configState = ConfigComponents.get(common).config;

    const currentEvent = eventId.getEventModel();

    if (currentEvent === null) {
        return null;
    }
    return (
        <>
            <RaceCaption variant={configState.componentVariants.sportsbookVariant}>
                <RunnerCaption>
                    <I18n
                        langKey='events.race-summary.runner.label'
                        defaultText='Runner'
                    />
                </RunnerCaption>
                <SelectionCaption variant={configState.componentVariants.sportsbookVariant}>
                    <I18n
                        langKey='events.race-summary.price.label'
                        defaultText='Price'
                    />
                </SelectionCaption>
            </RaceCaption>

            {state.markets.map((market) => (
                <RaceSummaryRowMarket
                    key={market.id2.key}
                    marketId={market.id2}
                />
            ))}
            {props.config.displayShowMoreButton === true && state.shouldShowMoreLessButton ? (
                <ExpandButton
                    isExpanded={state.isShownMore}
                    toggleExpand={state.showMoreToggle}
                />
            ) : null}
        </>
    );
});
